<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card>
            <v-overlay v-model="overlay"
                    color= "#FE5800" >
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card-title class="pa-0">
                <v-container style="" class="">

                    <v-row align="center" justify="center">

                        <v-col cols="12" sm="12" md="12">


                            Add Retail Item


                        </v-col>


                    </v-row>

                </v-container>
            </v-card-title>
            <v-card-text>
                <v-divider></v-divider>
                <v-form v-model="valid" enctype="multipart/form-data" id="createRetailItem" autocomplete="off">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12">
                                <h4 class="title">Retail Item Information</h4>
                            </v-col>
                        </v-row>

                        <v-row align="center">
                            <v-col cols="3" md="3" class="font-weight-bold" style="font-size:18px;" >
                                {{$t('zz_separator')}}
                            </v-col>
                            <v-col cols="3" md="3">
                                <v-switch label="" v-model="sepretor" color="success"></v-switch>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field
                                v-model="retailitemname"
                                name="retailitemname"
                                :label="$t('zz_retail_item_name')"
                                required
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('retailitemname')"
                                data-vv-name="retailitemname"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field
                                v-model="hashtags"
                                name="hashtags"
                                :label="$t('zz_retail_hashtag')"
                                required
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('retailitemname')"
                                data-vv-name="retailitemname"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="6" md="6" >
                                <v-text-field
                                v-model="subtitle"
                                name="subtitle"
                                :label="$t('zz_sub_title')"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" >
                                <v-text-field
                                v-model="productcode"
                                name="productcode"
                                :label="$t('zz_product_code')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <v-text-field
                                v-model="categoryname"
                                name="categoryname"
                                label="Category Name"
                                >
                                </v-text-field>

                            </v-col>
                            <v-col cols="6">
                                <v-btn color="primary" tile class="ml-auto  font-weight-bold" @click="addcateggory">Add Category</v-btn>

                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6" sm="6">
                                <v-autocomplete
                                label="Retail Category"
                                v-model="retailcategory_id"
                                name="retailcategory_id"
                                item-text="name"
                                item-value="id"
                                :items="retailcategories"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="brand"
                                name="brand"
                                :label="$t('zz_brand')"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>

                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="size"
                                name="size"
                                :label="$t('zz_size')"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="price"
                                name="price"
                                :label="$t('zz_price')"
                                @keyup="getper"
                                required
                                v-validate="'required|max:255'"

                                :error-messages="errors.collect('price')"
                                data-vv-name="price"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="saleprice "
                                @keyup="getper"
                                name="saleprice"
                                :label="$t('zz_sale_price')"
                                required
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('saleprice')"
                                data-vv-name="saleprice"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="salepricediscountpercentage "
                                 @keyup="getdiscountper"
                                name="salepricediscountpercentage"
                                :label="$t('zz_discount_percentage')"
                                ></v-text-field>
                            </v-col>
                            <!-- <v-col cols="12" class="spaced">
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/es.svg" width="30px"> <span class="tooltiptext">España</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gb.svg" width="30px"> <span class="tooltiptext">UK</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/de.svg" width="30px"> <span class="tooltiptext">Germany</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/se.svg" width="30px"> <span class="tooltiptext">Sweden</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/ru.svg" width="30px"> <span class="tooltiptext">Russia</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/fr.svg" width="30px"> <span class="tooltiptext">France</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/it.svg" width="30px"> <span class="tooltiptext">Italy</span></div>
                                        <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gr.svg" width="30px"> <span class="tooltiptext">Greece</span></div>
                                    </v-col> -->
                            <v-col cols="12" md="12">

                                <v-textarea
                                v-model="description"
                                name="description"
                                label="Retail Item Description"
                                ></v-textarea>

                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="extra1"
                                name="extra1"
                                label="Extra1"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="extra2"
                                name="extra2"
                                label="Extra2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="extra3"
                                name="extra3"
                                label="Extra3"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" md="6" sm="6">
                                <v-text-field
                                v-model="extra4"
                                name="extra4"
                                label="Extra4"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="!sepretor">
                                <v-col cols="12" md="6" sm="6">

                                    <Cropper classname="cropper" :src="mainimg" @change="onChangeImage"/>



                                    <v-row>
                                        <v-col cols="12" md="12" sm="12" align="center">
                                            <v-btn color="primary" @click="$refs.imgfile.click()">

                                                <input type="file" ref="imgfile" @change="mainim($event)" accept="image/*" class="d-none" id="mainimage"/>{{$t('zz_upload_image')}}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col col="12" md="6" sm="6">
                                    <img style="max-width:100%"  :src="mainimage"  class="grey lighten-2"  max-height="300"  v-if="mainimage!=null" />
                                </v-col>
                            </v-row>

                        </v-row>

                        <v-divider></v-divider>

                        <v-row v-if="!sepretor">
                            <v-col cols="12" md="12">
                                <h4 class="title">Gallery</h4>
                            </v-col>
                        </v-row>

                        <v-card elevation="3" class="pa-3 mb-3" v-if="!sepretor">


                            <v-row v-for="(item, index) in galleries" :key="index">

                                <v-col cols="12" md="11">


                                    <v-file-input
                                    accept="image/png, image/jpeg, image/bmp"
                                    placeholder="Pick an Gallery Image"
                                    prepend-icon="mdi-camera"
                                    label="Gallery Image"
                                    :id="'img'+index"
                                    :name="'imageurl['+index+']'"

                                    ></v-file-input>

                                </v-col>

                                <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                    <v-row class="">
                                    <v-col cols="12" md="12" sm="12">
                                        <a @click="galleries.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                    </v-col>
                                    </v-row>

                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-btn class="add " color="primary" @click="addgallery">{{$t('zz_add_new')}}</v-btn>
                                </v-col>
                            </v-row>

                        </v-card>

                        <v-divider></v-divider>
                        <div class="my-3">
                        <v-btn color="primary" @click="submit">{{$t('zz_save_and_exit')}}</v-btn>
                        </div>

                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
        <v-footer padless fixed class="footer-1">
                <v-row class="py-2 pl-5">
                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="21" large  @click="submit">{{$t('zz_save')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click="submit">{{$t('zz_save')}}</v-btn>
                </v-row>
            </v-footer>
    </v-container>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import { Cropper } from 'vue-advanced-cropper'

export default
{
    props:
    {
        source: String
    },
    data: () => ({
        sepretor:false,
        categoryname:'',
        productcode:'',
        overlay: false,
        valid: true,
        retailitemname:'',
        hashtags:'',
        subtitle:'',
        description:"",
        dictionary:
        {
            attributes: {
                name: "Retail Item Name",
            },
            custom: {}
        },
        mainimage:null,
        galleries:[{'imageurl':''}],
        imageurl:'',
        business_id:0,
        retailcategories:[],
        brand:'',
        saleprice:'',
        retailcategory_id:0,
        salepricediscountpercentage:0,
        size:'',
        price:'',
        mainimg:null,
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0
      },
      extra1:'',
      extra2:'',
      extra3:'',
      extra4:'',



    }),
    mounted() {
      this.$validator.localize("en", this.dictionary);
    },
    components: {
      Cropper
    },
    created()
    {
        // if(this.$route.params.business_id)
        // {
        //     this.business_id=this.$route.params.business_id;
        // }
        this.storeBusiness=JSON.parse(localStorage.getItem('business'));

        this.business_id=this.storeBusiness.id;

        this.fetchRetailCategories();
    },
    methods:{
        getper(event)
        {
            let saleprice=this.saleprice;
            let discount=0;

            if(saleprice>0 && this.price>0)
            {
                discount=(this.price-this.saleprice)/100;
            }


            this.salepricediscountpercentage=discount;

        },
        getdiscountper()
        {
            let discount=0;
            let salep=0;

            if(this.price>0)
            {
                discount=(this.price*this.salepricediscountpercentage)/100;
                salep=this.price-discount;

            }

            this.saleprice=salep;

        },
        addcateggory()
        {
            this.overlay=true;
            this.$http
            .post(this.$apidomain+"addcategory/"+ this.business_id,{ categoryname: this.categoryname })
            .then(res => {
                if(res.data.success==1)
                    {

                        // this.$router.go('/');
                        this.fetchRetailCategories();
                        this.categoryname="";
                        this.overlay=false;


                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        this.overlay=false;

                        alert(errmsg[0]);
                    }
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
        },
        fetchRetailCategories()
        {
            this.$http
            .get(this.$apidomain+"retailcategorylistpwa/"+this.business_id)
            .then(res => {
            this.retailcategories = res.data.retailcategory;
            //console.log("types "+ this.types);
            })
            .catch(err => {
            console.log(err.response);
            });
        },

        onChangeImage({coordinates, canvas})
        {
            this.coordinates = coordinates

            this.mainimage = canvas.toDataURL()
        },

        addgallery()
        {
         this.galleries.push({'imageurl':''})
        },
        mainim(event)
        {
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.mainimg = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]),
                  n = bstr.length,
                  u8arr = new Uint8Array(n);

            while(n--){
                  u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
        submit()
        {
            let th = this;
            if (this.$validator.validateAll())
            {
                let fd = new FormData(document.getElementById("createRetailItem"));

                fd.append('businesses_id',this.business_id);

                fd.append('retailcategory_id',this.retailcategory_id);

                if(this.mainimg!=null)
                {
                    fd.append('mainimage',this.dataURLtoFile(this.mainimage,document.getElementById('mainimage').files[0].name));
                }

                this.overlay=true;

                if(this.sepretor)
                {
                fd.append('separation',1);

                }
                else
                {
                fd.append('separation',0);
                }

                this.$http
                .post(this.$apidomain+"createRetailItem", fd)
                .then(res => {
                if(res.data.success)
                {
                    // this.$router.push("/agent/retailitemlist/"+this.business_id);
                        this.$router.push({name:'retailitemlist'});


                    this.overlay=false;
                }
                else
                {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        // alert(errmsg[0]);
                        this.overlay=false;
                }
                })
                .catch(err => {
                console.log(err.response);
                this.overlay=false;
                });

            }
        }
    }

}
</script>
<style >
    .cropper {
	border: solid 1px #EEE;
	height: 300px;
	width: 100%;
}
</style>
